export default __webpack_public_path__ + "static/media/Bell.02bf959b.svg";